import service from "./service";

/**
 * CreateProject
 * @param {object} payload
 * @param {string} payload.name
 * @param {string} payload.description
 * @param {string} payload.startDate
 * @param {string} payload.endDate
 * @param {Array} payload.managerList
 * @param {Array} payload.supervisorList
 */
async function createProject(payload) {
  try {
    const res = await service.createProject(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * UpdateProject
 * @param {object} payload
 * @param {string} payload.id
 * @param {string} payload.name
 * @param {string} payload.description
 * @param {string} payload.startDate
 * @param {string} payload.endDate
 * @param {Array} payload.managerList
 * @param {Array} payload.supervisorList
 */
async function updateProject(payload) {
  try {
    const res = await service.updateProject(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * DeleteProjects
 * @param {object} payload
 * @param {Array} payload.projectIds
 */
async function deleteProjects(payload) {
  try {
    const res = await service.deleteProjects(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * GetProjectDetail
 * @param {object} payload
 * @param {string} payload.id
 */
async function getProjectDetail(payload) {
  try {
    const res = await service.getProjectDetail(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * GetProjectModifyDetail
 * @param {object} payload
 * @param {string} payload.id
 */
async function getProjectModifyDetail(payload) {
  try {
    const res = await service.getProjectModifyDetail(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getProjectTasks
 * @param {object} payload
 * @param {string} payload.id
 * @param {number} payload.findSkip
 * @param {number} payload.findLimit
 * @param {string} payload.sort
 * @param {string} payload.order
 */
async function getProjectTasks(payload) {
  try {
    const res = await service.getProjectTasks(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getProjectPeoples
 * @param {object} payload
 * @param {string} payload.id
 * @param {string} payload.role
 * @param {number} payload.findSkip
 * @param {number} payload.findLimit
 * @param {string} payload.sort
 * @param {string} payload.order
 */
async function getProjectPeoples(payload) {
  try {
    const res = await service.getProjectPeoples(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * updateProjectStatus
 * @param {object} payload
 * @param {string} payload.id
 * @param {number} payload.status
 */
async function updateProjectStatus(payload) {
  try {
    const res = await service.updateProjectStatus(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * isProjectWorkResume
 * @param {object} payload
 * @param {string} payload.id
 */
async function isProjectWorkResume(payload) {
  try {
    const res = await service.isProjectWorkResume(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getProjectWorkedCount
 * @param {object} payload
 * @param {string} payload.id
 * @param {string} payload.targetWorkloadType
 */
async function getProjectWorkedCount(payload) {
  try {
    const res = await service.getProjectWorkedCount(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function updateProjectTargetWorkload(payload) {
  try {
    const res = await service.updateProjectTargetWorkload(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * GetContractTemplates
 * @param {object} payload
 * @param {string} payload.templateId
 */
async function getContractTemplates(payload) {
  try {
    const res = await service.getContractTemplates(payload);
    return res;
  } catch (error) {
    return null;
  }
}

export default {
  getProjectDetail,
  getProjectModifyDetail,
  createProject,
  updateProject,
  deleteProjects,
  getProjectTasks,
  getProjectPeoples,
  updateProjectStatus,
  isProjectWorkResume,
  getProjectWorkedCount,
  updateProjectTargetWorkload,
  getContractTemplates,
};
